export default function maturityDomainDirective() {
  return {
    template: require('./maturity-domain.html'),
    scope: {
      maturityDomain: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'ECATMaturityDomainController',
    controllerAs: 'maturityDomainVM',
    bindToController: true,
    replace: true,
  };
}
